module.exports = __webpack_public_path__ + "media/images/icons/logout-21c9272aea8f299944f70f893fdfa139.svg";